import en from './json/en.json'
import hk from './json/hk.json'
import vi from './json/vi.json'
// 台灣和香港用同一個語言json
import tw from './json/hk.json'
export const defaultLang = 'en'
export const supportedLangs = [/*'en', */'vi', 'hk', 'tw']
export const langMap = {
  en: 'English',
  vi: 'Vietnam',
  hk: 'Hongkong',
  tw: 'Taiwan',
}
export const i18nMessages = {
  en,
  vi,
  hk,
  tw
}
